import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import {Link} from "react-router-dom";

import qr_code from "../../../resources/images/qr-codes-android/kierowca.png";
import qr_code_testy from "../../../resources/images/qr-codes-android/kierowca-testy.png";
import {TopAlertInformacja} from "../../../componentsTopsa/alerty/TopAlerts";
import LppService from "../LppService";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../utilities/TabGrid";
import TabUtilities from "../../../utilities/TabUtilities";
import {TopInputDate} from "../../../componentsTopsa/inputs/TopInputs";
import moment from "moment";
import TopExportCSV from "../../../componentsTopsa/exportCSV/TopExportCSV";

export default class Odbicia extends Component {
    constructor(props) {
        super(props);
        this.state = {
            odbiciaPop: [],
            odbiciaNie: [],
            dataOd: moment().startOf('month'),
            dataDo: moment().endOf('month'),
            kolumnyDoExportuDefault: [
                {value: "nrkarty", label: "Nr karty"},
                {value: "naztr", label: "Nazwa trasy"},
                {value: "nazmi", label: "Miejscowość"},
                {value: "nazpr", label: "Przystanek"},
                {value: "imie", label: "Imie"},
                {value: "nazwisko", label: "Nazwisko"},
                {value: "dataodbicia", label: "Data odbicia"},
            ],
            wszystkieKolumnyEksport: [
                {value: "nrkarty", label: "Nr karty"},
                {value: "naztr", label: "Nazwa trasy"},
                {value: "nazmi", label: "Miejscowość"},
                {value: "nazpr", label: "Przystanek"},
                {value: "imie", label: "Imie"},
                {value: "nazwisko", label: "Nazwisko"},
                {value: "dataodbicia", label: "Data odbicia"},
            ],
        };
    }

    componentDidMount() {
        this.pobierzPoprawneOdbicia();
        this.pobierzNiePoprawneOdbicia();
    }

    pobierzPoprawneOdbicia = () => {
        let dOd = moment(this.state.dataOd).format('YYYY-MM-DD');
        let dDo = moment(this.state.dataDo).format('YYYY-MM-DD');

        LppService.pobierzOdbiciaPoprawne(dOd, dDo).then((response) => {
            // console.log(response.data);
            this.setState({odbiciaPop: response.data});
        }).catch((e) => {

        })
    }

    pobierzNiePoprawneOdbicia = () => {
        let dOd = moment(this.state.dataOd).format('YYYY-MM-DD');
        let dDo = moment(this.state.dataDo).format('YYYY-MM-DD');

        LppService.pobierzOdbiciaNiePoprawne(dOd, dDo).then((response) => {
            // console.log(response.data);
            this.setState({odbiciaNie: response.data});
        }).catch((e) => {

        })
    }

    onChangeDataOd = (e) => {
        this.setState({dataOd: moment(e)}, () => {
            this.pobierzPoprawneOdbicia();
            this.pobierzNiePoprawneOdbicia();
        });
    }

    onChangeDataDo = (e) => {
        this.setState({dataDo: moment(e)}, () => {
            this.pobierzPoprawneOdbicia();
            this.pobierzNiePoprawneOdbicia();
        });
    }

    formatData = (coll, row) => {
        return moment(coll).format('YYYY-MM-DD HH:mm')
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'Odbicia'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/lpp', text: 'Aplikacje Android'},
                                    {addressUrl: '/lpp/odbicia', text: 'Aplikacja eBus Driver'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12} style={{textAlign: 'center', marginTop: '10px'}}>
                            <label>Data od: </label>
                            <TopInputDate onChange={this.onChangeDataOd} value={this.state.dataOd}/>
                            <label style={{marginLeft: '15px'}}>Data do: </label>
                            <TopInputDate onChange={this.onChangeDataDo} value={this.state.dataDo}/>
                            <hr/>
                        </Col>
                        <Col lg={12}>
                            <Row>
                                <Col sm={12}>
                                    <h3><i className={'fa fa-check'} style={{color: 'green'}}/> Odbicia poprawne</h3>
                                    <TopExportCSV daneRest={this.state.odbiciaPop} wszystkieKolumny={this.state.wszystkieKolumnyEksport}
                                                  kolumnyDoExportu={this.state.kolumnyDoExportuDefault}/>
                                    <BootstrapTable data={this.state.odbiciaPop}
                                                    // options={options}
                                                    pagination
                                                    hover
                                    >
                                        <TableHeaderColumn dataField='nrkarty' isKey hidden={false}
                                                           thStyle={{width: '120px'}} tdStyle={{width: '120px'}}
                                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                        >Nr karty</TableHeaderColumn>
                                        <TableHeaderColumn dataField='naztr'
                                                           thStyle={{width: '180px'}} tdStyle={{width: '180px'}}
                                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                                                           // dataFormat={this.formatNazwa}
                                        >Nazwa trasy</TableHeaderColumn>
                                        <TableHeaderColumn dataField='nazmi'
                                                           thStyle={{width: '120px'}} tdStyle={{width: '120px'}}
                                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                                                           dataFormat={this.formatNip}
                                        >Miejscowość</TableHeaderColumn>
                                        <TableHeaderColumn dataField='nazpr'
                                                           // thStyle={{width: '110px'}} tdStyle={{width: '110px'}}
                                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                                        >Przystanek</TableHeaderColumn>
                                        <TableHeaderColumn dataField='imie'
                                                           thStyle={{width: '180px'}} tdStyle={{width: '180px'}}
                                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                                                           // dataFormat={this.formatAdres}
                                        >Imie</TableHeaderColumn>
                                        <TableHeaderColumn dataField='nazwisko'
                                                           thStyle={{width: '180px'}} tdStyle={{width: '180px'}}
                                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                                        >Nazwisko</TableHeaderColumn>
                                        <TableHeaderColumn dataField='dataodbicia'
                                                           thStyle={{width: '180px'}} tdStyle={{width: '180px'}}
                                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                                                           dataFormat={this.formatData}
                                        >Data odbicia</TableHeaderColumn>
                                    </BootstrapTable>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <Row>
                                <Col sm={12}>
                                    <h3><i className={'fa fa-times'} style={{color: 'red'}}/> Odbicia nie poprawne</h3>
                                    <TopExportCSV daneRest={this.state.odbiciaNie} wszystkieKolumny={this.state.wszystkieKolumnyEksport}
                                                  kolumnyDoExportu={this.state.kolumnyDoExportuDefault}/>
                                    <BootstrapTable data={this.state.odbiciaNie}
                                        // options={options}
                                                    pagination
                                                    hover
                                    >
                                        <TableHeaderColumn dataField='nrkarty' isKey hidden={false}
                                                           thStyle={{width: '120px'}} tdStyle={{width: '120px'}}
                                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                        >Nr karty</TableHeaderColumn>
                                        <TableHeaderColumn dataField='naztr'
                                                           thStyle={{width: '180px'}} tdStyle={{width: '180px'}}
                                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                                            // dataFormat={this.formatNazwa}
                                        >Nazwa trasy</TableHeaderColumn>
                                        <TableHeaderColumn dataField='nazmi'
                                                           thStyle={{width: '120px'}} tdStyle={{width: '120px'}}
                                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                                                           dataFormat={this.formatNip}
                                        >Miejscowość</TableHeaderColumn>
                                        <TableHeaderColumn dataField='nazpr'
                                            // thStyle={{width: '110px'}} tdStyle={{width: '110px'}}
                                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                                        >Przystanek</TableHeaderColumn>
                                        <TableHeaderColumn dataField='imie'
                                                           thStyle={{width: '180px'}} tdStyle={{width: '180px'}}
                                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                                            // dataFormat={this.formatAdres}
                                        >Imie</TableHeaderColumn>
                                        <TableHeaderColumn dataField='nazwisko'
                                                           thStyle={{width: '180px'}} tdStyle={{width: '180px'}}
                                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                                        >Nazwisko</TableHeaderColumn>
                                        <TableHeaderColumn dataField='dataodbicia'
                                                           thStyle={{width: '180px'}} tdStyle={{width: '180px'}}
                                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                                                           dataFormat={this.formatData}
                                        >Data odbicia</TableHeaderColumn>
                                    </BootstrapTable>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/lpp/odbicia/Odbicia.js